import {CdAddedAim} from '../../../interfaces/care/cd-care-plan/cd-added-aim';
import {CdNandaAim} from '../../../interfaces/care/cd-nanda/cd-nanda-aim';
import {CdAddedMeasure} from '../../../interfaces/care/cd-care-plan/cd-added-measure';
import {CdAddedMeasureFactory} from './cd-added-measure-factory';
import {CdAddedCustomMeasureFactory} from './cd-added-custom-measure-factory';
import {CdAddedCustomMeasure} from '../../../interfaces/care/cd-care-plan/cd-added-custom-measure';
import {CdAimEvaluation} from '../../../interfaces/care/cd-care-plan/cd-aim-evaluation';
import {CdAimEvaluationFactory} from './cd-aim-evaluation-factory';

export class CdAddedAimFactory {

  /**
   *
   * @param cdAddedAim
   */
  public static fromObject(cdAddedAim: any): CdAddedAim {
    return new class implements CdAddedAim {
      cdCarePlanId: number = cdAddedAim.c_care_plan_id;
      cdClarificationId: number = cdAddedAim.c_clarification_id;
      cdNandaAim: CdNandaAim = {
        id: cdAddedAim.c_care_plan_item_able_id,
        name: cdAddedAim.name,
        cdNandaMeasures: [],
        cdCustomMeasures: [],
        index: null
      };
      comment: string = cdAddedAim.comment;
      created: string = cdAddedAim.created;
      id: number = cdAddedAim.id;
      itemNumber: number = cdAddedAim.item_number;
      itemNumberString: string = cdAddedAim.item_number_string;
      modified: string = cdAddedAim.modified;
      parentId: number = cdAddedAim.parent_id;
      type: 'aim' = 'aim';
      userId: number = cdAddedAim.user_id;
      hasChangedFrequencies: boolean = cdAddedAim.has_changed_frequencies === null ? false : cdAddedAim.has_changed_frequencies;
      hasChangedMeasures: boolean = cdAddedAim.has_changed_measures;
      isAdded: boolean = cdAddedAim.is_added;
      appointment: string = cdAddedAim.appointment;
      cdAddedMeasures: CdAddedMeasure[] =
        cdAddedAim.measures ? CdAddedMeasureFactory.fromArray(cdAddedAim.measures) : [];
      cdAddedCustomMeasures: CdAddedCustomMeasure[] =
        cdAddedAim.custom_measures ? CdAddedCustomMeasureFactory.fromArray(cdAddedAim.custom_measures) : [];
      isLastVersionEvaluated: boolean = cdAddedAim.is_last_version_evaluated;
      isToDelete: boolean = cdAddedAim.is_to_delete;
      latestCdAimEvaluation: CdAimEvaluation = cdAddedAim.latest_c_evaluation ?
        CdAimEvaluationFactory.fromObject(cdAddedAim.latest_c_evaluation) : null;
    };
  }

  /**
   *
   * @param cdAddedAims
   */
  public static fromArray(cdAddedAims: any[]): CdAddedAim[] {
    return cdAddedAims.map((_cdAddedAim) => {
      return CdAddedAimFactory.fromObject(_cdAddedAim);
    });
  }

}
